import { createFeatureSelector, createSelector } from "@ngrx/store";
import { flowRateFeatureKey } from "./flow-rate-chart.reducer";

export const selectFlowRateState = createFeatureSelector(flowRateFeatureKey);

export const selectFlowRate = createSelector(
  selectFlowRateState,
  (state: any) => state
);
